document.addEventListener('DOMContentLoaded', function() {
  const progressBar = document.getElementById('scrollProgress');
  const mainContent = document.querySelector('.article-content');
  const tocSidebar = document.querySelector('.blog-toc-sidebar');

  let tocSticky = null;

  // Create TOC with sticky wrapper and header
  if (mainContent && tocSidebar) {
    const existingToc = mainContent.querySelector('ul, ol');

    if (existingToc) {
      // STEP 1: Get all headings (h1-h6) and add IDs
      const headings = mainContent.querySelectorAll('h1, h2, h3, h4, h5, h6');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          heading.id = `heading-${index}`;
        }
      });

      // STEP 2: Create TOC
      const newToc = document.createElement('ul');
      const isMobile = window.innerWidth <= 768;
      newToc.className = isMobile ? 'toc-list collapsed' : 'toc-list';
      newToc.id = 'tocList';

      // Level mapping for all heading types
      const levelMap = {
        'H1': 'level-1',
        'H2': 'level-2',
        'H3': 'level-3',
        'H4': 'level-4',
        'H5': 'level-5',
        'H6': 'level-6'
      };

      headings.forEach(heading => {
        const li = document.createElement('li');
        li.className = levelMap[heading.tagName] || 'level-1';

        const a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;
        a.style.cursor = 'pointer';

        a.addEventListener('click', function(e) {
          e.preventDefault();
          document.getElementById(heading.id)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });

        li.appendChild(a);
        newToc.appendChild(li);
      });

      // STEP 3: Sticky wrapper
      tocSticky = document.createElement('div');
      tocSticky.className = 'toc-sticky';

      // STEP 4: Header
      const tocHeader = document.createElement('div');
      tocHeader.className = 'toc-header';
      tocHeader.innerHTML = `
        <h3 class="toc-title">Table of Content</h3>
        <button class="toc-toggle ${isMobile ? 'collapsed' : ''}" id="tocToggle">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      `;

      tocSticky.appendChild(tocHeader);
      tocSticky.appendChild(newToc);

      tocSidebar.innerHTML = '';
      tocSidebar.appendChild(tocSticky);

      // Hide TOC on mobile
      if (isMobile) {
        tocSidebar.style.display = 'none';
      }

      // STEP 7: Toggle
      document.getElementById('tocToggle')?.addEventListener('click', function() {
        newToc.classList.toggle('collapsed');
        this.classList.toggle('collapsed');
      });

      // STEP 8: Active highlight
      const tocLinks = newToc.querySelectorAll('a');
      
      function updateActiveHeading() {
        let current = headings[0]?.id;

        // Find the LAST heading above viewport top
        for (let i = 0; i < headings.length; i++) {
          const rect = headings[i].getBoundingClientRect();
          if (rect.top <= 150) {
            current = headings[i].id;
          } else {
            break;
          }
        }

        tocLinks.forEach(link => {
          link.parentElement.classList.remove('active');
          if (link.getAttribute('href') === '#' + current) {
            link.parentElement.classList.add('active');
          }
        });
      }
      
      window.addEventListener('scroll', updateActiveHeading, { passive: true });
      updateActiveHeading(); // Call on page load
    }
  }

  /* =====================================================
     DESKTOP STICKY + FOOTER STOP
  ====================================================== */
  function handleTocSticky() {
    if (!tocSticky) return;

    // MOBILE: NO STICKY
    if (window.innerWidth <= 768) {
      tocSticky.style.position = 'static';
      tocSticky.style.top = '';
      tocSticky.style.bottom = '';
      tocSticky.style.left = '';
      tocSticky.style.right = '';
      return;
    }

    // DESKTOP ONLY
    const footer = document.querySelector('footer');
    if (!footer) return;

    const tocHeight = tocSticky.offsetHeight;
    const footerTop = footer.getBoundingClientRect().top + window.scrollY;
    const scrollTop = window.scrollY;
    const stopPoint = footerTop - tocHeight - 20;

    tocSticky.style.position = 'fixed';

    if (scrollTop > stopPoint) {
      tocSticky.style.top = `${stopPoint - scrollTop}px`;
    } else {
      tocSticky.style.top = 'unset';
    }
  }

  window.addEventListener('scroll', handleTocSticky, { passive: true });
  window.addEventListener('resize', handleTocSticky);
  handleTocSticky();

  // Progress bar
  function updateProgress() {
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = window.scrollY;
    const scrollPercent = docHeight > 0 ? (scrolled / docHeight) * 100 : 0;

    progressBar.style.width = scrollPercent + '%';
    progressBar.style.backgroundColor = '#B7D340';
    progressBar.style.display = 'block';
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();

  // Author
  const authorWrapper = document.querySelector('.author-wrapper');
  if (authorWrapper) {
    authorWrapper.classList.remove('d-none');
    authorWrapper.style.display = 'block';
  }
});

/* ================= MOBILE: MOVE TOC AFTER FIRST IMAGE ================= */
/* COMMENTED OUT - TOC hidden on mobile instead
document.addEventListener('DOMContentLoaded', function () {
  function moveTocAfterSecondContentImage() {
    if (window.innerWidth <= 768) {
      const tocSidebar = document.querySelector('.blog-toc-sidebar');
      const articleContent = document.querySelector('.article-content');
      const images = articleContent?.querySelectorAll('img');

      if (tocSidebar && images && images.length >= 2 && !tocSidebar.classList.contains('toc-moved')) {
        images[1].insertAdjacentElement('afterend', tocSidebar);
        tocSidebar.classList.add('toc-moved');
      }
    }
  }

  moveTocAfterSecondContentImage();
  window.addEventListener('resize', moveTocAfterSecondContentImage);
});
*/